var React = require('react');

function Np4 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.1019 32.3089H3.9357C1.96032 32.3089 0.409546 30.9612 0.409546 28.9858C0.409546 27.6566 1.07416 26.5489 1.96032 25.2197L21.0126 3.06583C22.3419 1.51506 23.228 0.628906 25.4434 0.628906C27.4188 0.628906 28.9695 2.17968 28.9695 4.15506V26.5489H32.0895C33.6403 26.5489 34.9695 27.8597 34.9695 29.4104C34.9695 30.9612 33.6403 32.3089 32.0895 32.3089H28.9695V38.272C28.9695 40.0628 27.4188 41.6135 25.4434 41.6135C23.6526 41.6135 22.1019 40.0628 22.1019 38.272V32.3089ZM22.1018 26.5489V10.5797L8.82799 26.5489H22.1018Z","fill":"white"}));
}

Np4.defaultProps = {"width":"35","height":"42","viewBox":"0 0 35 42"};

module.exports = Np4;

Np4.default = Np4;
